import script from "./FilterArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterArea.vue?vue&type=script&setup=true&lang=ts"

import "./FilterArea.vue?vue&type=style&index=0&id=84f9d232&lang=css"

const __exports__ = script;

export default __exports__